import React from "react";
import { RepliedMessage } from "../../RepliedMessage";
import { MessageType } from "../MessageItem/MessageType";
import { MessageHeaderContainer } from "../styles";

export default function MessageBody({
  message,
  setShowImage,
  customer,
  focusMessage,
}) {
  return (
    <MessageHeaderContainer>
      {message.message_quoted && (
        <RepliedMessage
          message={message.message_quoted}
          customer={customer}
          onClick={() => focusMessage(message.message_quoted)}
        />
      )}

      <MessageType message={message} setShowImage={setShowImage} />
    </MessageHeaderContainer>
  );
}
